module.exports = __webpack_public_path__ + "img/pinterest.e7fb86ce.svg";